
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gOIjats0BP9Kc3aYRM1wTrbrP68KOGI2sEjoYFfJTPTkMeta } from "/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index3zOoOjQAOiHFBjJR2BZ0poDiTu_457iWn4SKwL4CbySIkMeta } from "/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search9W59N2924ThVr7JSygAaobmfzjx3VsNRvQW1P9z28HEMeta } from "/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexOkpj7M9ItCFjGaXbOY7tobfX7qK0Xu54YxAXnb0eXmkMeta } from "/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93EXw8qJvi7WeaHhHMEKuS8jZ8qxDph0DwA_45CUwNgeciUMeta } from "/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexQvoYOgBlUjaVFZt2Om7U2_45Vs3iwxyvlTM1f_45Bvj4bCAMeta } from "/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_935yUedJlqmEysggDWwM_x1_TVCG6966xV9AEXfoG94ZIMeta } from "/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexWVmi8AhBEDKibGoqHpyT6Ajlw6bYyqc15zGlZQO48LwMeta } from "/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93pANBogvJCfhfW4LI5wLCp8x6O0tmxkj6jrXds1eWFuwMeta } from "/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexl1ugQVvbyFPmtu_SHP6ZXNQ4ATKhC77ZAupZfLeYpHcMeta } from "/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexhaudo86PVS_45rjZYU6BVNBwgAIOQfWUHzjZRBAiK8cokMeta } from "/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexQvoYOgBlUjaVFZt2Om7U2_45Vs3iwxyvlTM1f_45Bvj4bCAMeta || {},
    component: () => import("/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexWVmi8AhBEDKibGoqHpyT6Ajlw6bYyqc15zGlZQO48LwMeta || {},
    component: () => import("/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexl1ugQVvbyFPmtu_SHP6ZXNQ4ATKhC77ZAupZfLeYpHcMeta || {},
    component: () => import("/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexhaudo86PVS_45rjZYU6BVNBwgAIOQfWUHzjZRBAiK8cokMeta || {},
    component: () => import("/codebuild/output/src607773588/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]